import axios from 'axios';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (config.skipAuth) {
      return config;
    }

    const token = Cookies.get('accessToken'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const skipRedirect = error.config?.skipAuth;
      const pathname = window.location.pathname;
      const isPublicAuthPage =
        pathname.startsWith("/auth/signin") ||
        pathname.startsWith("/auth/reset-password") ||
        pathname.startsWith("/auth/password-reset") ||
        pathname.startsWith("/auth/password-change") ||
        pathname.startsWith("/reset-password") ||
        pathname.startsWith("/forgot-password");

      if (!skipRedirect && !isPublicAuthPage) {
        console.error("Unauthorized, logging out ...");
        Cookies.remove("accessToken");

        if (pathname !== "/auth/signin") {
          window.location.assign("/auth/signin");
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
